module.exports = require("./../../_gen/starling/text/BitmapFontType");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/text/BitmapFontType.js
// module id = 226
// module chunks = 0